import React from "react";
import { Button, Row, Col, Modal, Icon, notification } from "antd";
import { connect } from "react-redux";
import get from "lodash/get";

import FormBuilderCustomView from "./FormBuilderCustomView";

import {
  getCustomFormPermissionBySlug,
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";
import { logout } from "../../reducers/user/actions";
import {
  getCustomFormSchema,
  getCustomFormData,
  postCustomFormSchema,
} from "../../api/requests";

class FormBuilderCustomViewContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      formSchema: null,
      formData: null,
    };
  }

  async componentDidMount() {
    try {
      const { data: formSchema } = await getCustomFormSchema(this.props.slug);
      const { data: formData } = await getCustomFormData(
        this.props.slug,
        this.props.subjectID
      );

      this.setState({
        formSchema,
        formData,
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  onSubmit = async (values) => {
    const schema = get(this.state, "formSchema.schema");
    const isUpload = Object.keys(schema).some((k) =>
      Object.keys(schema[k].fields).some(
        (o) => schema[k].fields[o].type === "InputUpload"
      )
    );

    let data = {};

    if (isUpload) {
      const formData = new FormData();

      Object.keys(values).forEach((key) => {
        if (values[key] && values[key].file) {
          formData.append(key, values[key].file);
        } else {
          formData.append(key, values[key]);
        }
      });

      data = formData;
    } else {
      data = { ...values };
    }

    await postCustomFormSchema(this.props.slug, this.props.subjectID, data);
  };

  getForm = () => {
    const { slug, isEditable, site, isPreview } = this.props;
    const { formSchema, formData } = this.state;

    return formSchema && formData ? (
      <FormBuilderCustomView
        site={site}
        isEditable={isEditable !== undefined ? isEditable : getCustomFormPermissionBySlug({
          slug: this.props.slug,
          type: "update",
        })(this.props.state)}
        schema={formSchema.schema}
        initialValues={get(
          formData,
          "data"
        )}
        updatedBy={get(
          formData,
          "updated_by.email"
        )}
        updatedOn={get(
          formData,
          "updated_on"
        )}
        onFormSubmit={this.props.onSubmit}
        name={formSchema.name}
        slug={slug}
        onSubmit={this.onSubmit}
        isPreview={isPreview}
      />
    ) : (
      <Icon type="loading" />
    );
  };

  render() {
    const { slug, isModal = true } = this.props;

    return (
      <div>
        {isModal ? (
          <Modal visible={!!slug} onCancel={this.props.onCancel} footer={null}>
            {this.getForm()}
          </Modal>
        ) : (
          this.getForm()
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  state,
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});

const mapDispatchToProps = { logout };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormBuilderCustomViewContainer);



// WEBPACK FOOTER //
// ./src/containers/FormBuilder/FormBuilderCustomViewContainer.js